import React from 'react';
import { Popconfirm, message, Spin } from 'antd';
import {
  EditOutlined,
  SaveOutlined,
  DeleteOutlined,
  ThunderboltOutlined,
  PlusCircleOutlined,
  EuroCircleOutlined,
  EyeOutlined,
  ForkOutlined
} from '@ant-design/icons';
import {
  saveToMcore,
  checkUsersExceptions,
  checkUsersDifferences
} from '../Users/services';
import { useStateLabel } from '../../libs/debug';
import { DEFAULT_USERS } from './../../config';
import { flagEmoji } from '../../libs/helpers';
import './users.css';
import { Button } from 'antd';

const Actions = params => {
  let {
    current,
    userIdEditing,
    setUserIdEditing,
    setLoadingCozSaving,
    isMultiselector,
    setIsMultiselector,
    routesChanges,
    resetTable,
    resetChanges,
    isForceUpdating
  } = params;

  const [defaultIsEditing, setDefaultIsEditing] = useStateLabel(
    false,
    'defaultIsEditing'
  );
  const [isActive, setIsActive] = useStateLabel(false, 'isActive');
  const [exceptions, setExceptions] = useStateLabel([], 'exceptions');
  const [exceptionsTitle, setExceptionsTitle] = useStateLabel(
    '',
    'exceptionsTitle'
  );
  const [differences, setDifferences] = useStateLabel([], 'differences');
  const [differencesTitle, setDifferencesTitle] = useStateLabel(
    '',
    'differencesTitle'
  );
  message.config({
    duration: 5
  });

  const saveChanges = async () => {
    await saveToMcore(routesChanges);
  };

  const checkUsersExceptionsRequest = async () => {
    const usersExceptions = await checkUsersExceptions(routesChanges);
    setExceptions(usersExceptions);
    setExceptionsTitle(
      usersExceptions.length ? 'Users exceptions' : 'No exceptions to show'
    );
  };

  const checkUsersDifferencesRequest = async userId => {
    const usersDifferences = await checkUsersDifferences(userId);
    setDifferences(usersDifferences);
    setDifferencesTitle(
      usersDifferences.length ? 'Users differences' : 'No differences to show'
    );
  };

  const getIcon = {
    price: <EuroCircleOutlined />,
    added: <PlusCircleOutlined />,
    removed: <DeleteOutlined />
  };

  return (
    <>
      <a
        onClick={async () => {
          setUserIdEditing(current.id);
          setDefaultIsEditing(
            DEFAULT_USERS.find(({ id }) => id === current.id)
          );
        }}
        disabled={userIdEditing && current.id !== userIdEditing}
      >
        {current.id !== userIdEditing && <EditOutlined />}
      </a>
      <Popconfirm
        title="The changes will be cancelled"
        onConfirm={() => {
          resetTable();
          setDefaultIsEditing(false);
        }}
        cancelText="No, wait"
        okText="Yes, cancel them"
      >
        <a>{current.id === userIdEditing ? <DeleteOutlined /> : null}</a>
      </Popconfirm>
      <a
        style={{ marginLeft: '15px' }}
        onClick={async () => {
          let newArr = isMultiselector;
          if (isMultiselector.includes(current.id)) {
            newArr = newArr.filter(id => id !== current.id);
            message.warning('Multiselector desactivated');
          } else {
            newArr.push(current.id);
            message.success('Multiselector activated');
          }
          setIsActive(newArr.includes(current.id)); // it doesn't do anything, but if removed, className doesn't work ??
          setIsMultiselector(newArr);
        }}
      >
        <ThunderboltOutlined
          className={!isMultiselector.includes(current.id) && 'disabledColor'}
        />
      </a>
      {DEFAULT_USERS.find(({ id }) => id === current.id) && (
        <Popconfirm
          title={
            <div>
              {exceptionsTitle ? (
                <span style={{ color: '#241dba' }}>{exceptionsTitle}</span>
              ) : (
                <div
                  style={{
                    margin: '25px'
                  }}
                >
                  <Spin />
                </div>
              )}
              <br />
              {exceptions.map((c, idx) => (
                <div>
                  <span style={{ color: '#241dba' }} key={++idx}>
                    {c.userName}
                  </span>
                  <br />
                  {c.routes.map((c, idx2) => (
                    <span key={++idx2}>
                      <a>{getIcon[c.change]} </a>
                      {c.country} {flagEmoji(c.country)} | {c.mccmnc}
                      {c.change === 'added' && ` | ${c.exceptionText}`}
                      {c.change === 'removed' && ` | ${c.exceptionText}`}
                      {c.change === 'price' && ` | ${parseFloat(c.price)}€`}
                      <br />
                    </span>
                  ))}
                  <br />
                </div>
              ))}
            </div>
          }
          loading={true}
          okText="Ok"
          onConfirm={() => {
            setExceptions([]);
            setExceptionsTitle('');
          }}
          cancelButtonProps={{ className: 'd-none' }}
        >
          <a
            disabled={
              !routesChanges.find(r => `${r.userId}` === `${current.id}`)
            }
            onClick={async () => {
              checkUsersExceptionsRequest();
            }}
          >
            <EyeOutlined style={{ marginLeft: '15px' }} />
          </a>
        </Popconfirm>
      )}
      {!DEFAULT_USERS.find(({ id }) => id === current.id) && (
        <Popconfirm
          title={
            <div>
              {differencesTitle ? (
                <>
                  <span style={{ color: '#241dba' }}>Glossary</span>
                  <br />
                  <span style={{ color: '#241dba' }}>
                    {getIcon['price']}
                    {` `}
                  </span>
                  <span>Difference in price - user vs default</span>
                  <br />
                  <span style={{ color: '#241dba' }}>
                    {getIcon['added']}
                    {` `}
                  </span>
                  <span>The user has this route, but not the default one</span>
                  <br />
                  <span style={{ color: '#241dba' }}>
                    {getIcon['removed']}
                    {` `}
                  </span>
                  <span>The default has this route, but not the user</span>
                  <br />
                  <br />
                  <span style={{ color: '#241dba' }}>{differencesTitle}</span>
                </>
              ) : (
                <div
                  style={{
                    margin: '25px'
                  }}
                >
                  <Spin />
                </div>
              )}
              <br />
              {differences.map((c, idx) => (
                <div key={++idx}>
                  <span>
                    <span style={{ color: '#241dba' }}>
                      {getIcon[c.change]}
                      {` `}
                    </span>
                    {c.userRoute?.country || c.defaultRoute.country}{' '}
                    {flagEmoji(c.userRoute?.country || c.defaultRoute.country)}{' '}
                    | {c.userRoute?.mccmnc || c.defaultRoute.mccmnc}
                    {c.change === 'price' &&
                      ` | ${parseFloat(c.userRoute.price)}€ vs ${parseFloat(
                        c.defaultRoute.price
                      )}€`}
                  </span>
                </div>
              ))}
            </div>
          }
          loading={true}
          okText="Ok"
          onConfirm={() => {
            setDifferences([]);
            setDifferencesTitle('');
          }}
          cancelButtonProps={{ className: 'd-none' }}
        >
          <a
            onClick={async () => {
              checkUsersDifferencesRequest(current.id);
            }}
          >
            <ForkOutlined style={{ marginLeft: '15px' }} />
          </a>
        </Popconfirm>
      )}
      {routesChanges.find(r => `${r.userId}` === `${current.id}`) ? (
      <Popconfirm
        title={
          <div>
            {!isForceUpdating
              ? defaultIsEditing
                ? 'This is a Default user, others users with these routes will be affected'
                : 'These changes will be saved'
              : 'Saving is forbidden while force update is running'}
            <br />
            {!isForceUpdating &&
              routesChanges.map((c, idx) => (
                <span key={++idx}>
                  <a>{getIcon[c.change]} </a>
                  {c.country} {flagEmoji(c.country)} | {c.mccmnc}
                  {c.change === 'added' && ` | ${c.price}€`}
                  {c.change === 'price' && ` | ${c.oldPrice}€ → ${c.price}€`}
                  <br />
                </span>
              ))}
          </div>
        }
        onConfirm={async () => {
          if (!isForceUpdating) {
            setLoadingCozSaving(true);
            try {
              await saveChanges();
              resetChanges();
            } catch (err) {
              console.log(err);
            }
          }
        }}
        cancelText={!isForceUpdating ? 'No, wait' : ''}
        okText={!isForceUpdating ? 'Yes, save them' : 'Ok'}
      >
        <Button
          type="link"
          icon={<SaveOutlined />}
          style={{ marginLeft: '15px' }}
        >         
        </Button>
      </Popconfirm>
    ) : (
      <Button
        type="link"
        icon={<SaveOutlined />}
        style={{ marginLeft: '15px', opacity: 0.5 }}
        disabled
      >       
      </Button>
    )}

    </>
  );
};

export default Actions;
